import { Action, createReducer, on } from '@ngrx/store';
import { IUserRolesResponse } from '../models/user-roles.model';
import { fromStaticDataAllUserRolesActions } from '../actions';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';

export const allUserRolesFeatureKey = 'allUserRoles';

export interface AllUserRolesState {
  allUserRolesResponse: IUserRolesResponse[];
  allUserRolesFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: AllUserRolesState = {
  allUserRolesResponse: undefined,
  allUserRolesFailure: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromStaticDataAllUserRolesActions.loadAllRoles, (state, action) => ({
    ...state,
    loaded: true
  })),

  on(fromStaticDataAllUserRolesActions.loadAllRolesSuccess, (state, action) => ({
    ...state,
    allUserRolesResponse: action.response
  })),

  on(fromStaticDataAllUserRolesActions.loadAllRolesFailure, (state, action) => ({
    ...state,
    allUserRolesFailure: action.error
  }))
);

export const getAllUserRolesResponse = (state: AllUserRolesState) => state.allUserRolesResponse;
export const getAllUserRolesFailure = (state: AllUserRolesState) => state.allUserRolesFailure;
export const getAllUserRolesIsLoaded = (state: AllUserRolesState) => state.loaded;
